import { useSearch } from '@tanstack/react-router';

import { AdvancedError } from '../../common/Error/AdvancedError';
import { LoadingIndicator } from '../../common/LoadingIndicator/LoadingIndicator';
import { useCustomerStatistics } from '../hooks/useCustomerStatistics';

import { CustomerStatisticsContent } from './CustomerStatisticsContent';
import { CustomerStatisticsTabSwitch } from './CustomerStatisticsTabSwitch';
import { NoStatistics } from './NoStatistics';
import { StatisticsCenteredFrame } from './StatisticsCenteredFrame';

export const CustomerStatistics = () => {
    const search = useSearch({ from: '/_app/statistics' });

    const customerStatisticsQuery = useCustomerStatistics({
        from: search.from,
        to: search.to,
        customerIds: search.customerIds,
    });

    if (customerStatisticsQuery.isPending) {
        return (
            <div>
                <CustomerStatisticsTabSwitch />
                <StatisticsCenteredFrame>
                    <LoadingIndicator />
                </StatisticsCenteredFrame>
            </div>
        );
    }

    if (customerStatisticsQuery.isError) {
        return (
            <StatisticsCenteredFrame>
                <AdvancedError />
            </StatisticsCenteredFrame>
        );
    }

    if (customerStatisticsQuery.data?.general.completedCount === 0) {
        return (
            <div>
                <CustomerStatisticsTabSwitch />
                <StatisticsCenteredFrame>
                    <NoStatistics />
                </StatisticsCenteredFrame>
            </div>
        );
    }

    return (
        <div>
            <CustomerStatisticsTabSwitch />
            <CustomerStatisticsContent statistics={customerStatisticsQuery.data} />
        </div>
    );
};
